<template>
  <div>
    <h1>Matriz IPER</h1>
    <hr class="hr-filter-info" />
    <div class="row mb-5">
      <div class="col-md-4">
        <SelectSearch
          placeholder="Seleccionar Área"
          name="name"
          label="Área"
          :options="areas"
          :loading="loadingArea"
          :disabled="false"
          @input="(value) => selectedArea(value)"
        />
      </div>
    </div>
    <div v-if="formData.area">
      <button
        class="button-filter-matriz"
        @click.prevent="isFilter = !isFilter"
      >
        Filtros
        <img
          src="@/assets/images/icons/icon-matriz-iper/icon-filter.png"
          alt=""
        />
      </button>
      <div class="mt-4">
        <FilterMatrizIper
          v-if="isFilter"
          :isLoadingActivitiesArea="isLoadingActivitiesArea"
          @submitFilter="submitFilter"
        />
      </div>
    </div>
    <AllAreasActivities
      v-if="formData.area"
      :dataTable="dataTable"
      :loading="isLoadingActivitiesArea"
      :risks="risks"
      @loadRowsPag="loadRowsPagActivitiesArea"
    />
    <div v-if="formData.area">
      <hr class="hr-filter-info" />
      <h1>Identificar peligros y evaluar riesgos</h1>
      <div class="mb-4 row">
        <div class="col-md-4">
          <SelectSearch
            placeholder="Seleccionar Cargo"
            name="name"
            label="Cargo"
            :options="positions"
            :loading="loadingPosition"
            :disabled="false"
            :value="formData.position"
            @input="(value) => selectedPosition(value)"
            @search="(value) => searchPosition(value)"
          />
        </div>
      </div>
      <hr class="hr-filter-info" />
      <AlertComponent
        v-if="!formData.area || !formData.position"
        :text="'Selecciona un Área y un Cargo para poder identificar peligros y evaluar riesgos. Tambien puedes usar el filtro para consultar estados de las áreas y vigencias de matriz.'"
      />
      <Area
        v-if="formData.area && formData.position"
        :title="title"
        :idPosition="idPosition"
        :idArea="formData.area?.id"
        :loadingDetailArea="loadingDetailArea"
        :dataDetailArea="dataDetailArea"
        :risks="risks"
        @loadRowsPag="loadRowsPag"
      />
    </div>
  </div>
</template>

<script>
import { getAreas } from "@/services/health-tracker/diagnostic/service";
import {
  getPositionByArea,
  getAreaDetail,
  getAreaActivities,
} from "@/services/health-tracker/matrizIper/service";
import AlertComponent from "./components/AlertComponent.vue";
import FilterMatrizIper from "./components/FilterMatrizIper.vue";
import Area from "./components/Area.vue";
import SelectSearch from "./components/SelectSearch.vue";
import AllAreasActivities from "./components/AllAreasActivities.vue";
export default {
  name: "MatrizIper",
  components: {
    FilterMatrizIper,
    AlertComponent,
    Area,
    SelectSearch,
    AllAreasActivities,
  },
  data() {
    return {
      title: "",
      loadingArea: false,
      loadingPosition: false,
      loadingDetailArea: false,
      abortController: null,
      search: "",
      areas: [],
      positions: [],
      formData: {
        position: null,
        area: null,
      },
      isFilter: false,
      dataDetailArea: null,
      page: 1,
      pageAllActivitiesArea: 1,
      idPosition: null,
      abortControllerDetail: null,
      dataTable: {},
      isLoadingActivitiesArea: false,
      risks: [
        {
          id: 1,
          name: "Sin calificación",
          icon: require("@/assets/images/icons/icon-matriz-iper/sin-calification.png"),
          score: [0],
          text: "Sin registro de datos",
          background: "#ECEFF1",
          color: "#546E7A",
        },
        {
          id: 2,
          name: "Riesgo muy alto",
          icon: require("@/assets/images/icons/icon-matriz-iper/risk-muy-alto.png"),
          score: [401, 60000],
          text: "Detener está actividad especifica",
          background: "#FFF1F0",
          color: "#AC0000",
        },
        {
          id: 3,
          name: "Riesgo alto",
          icon: require("@/assets/images/icons/icon-matriz-iper/risk-alto.png"),
          score: [200, 400],
          text: "Requiere acción inmediata",
          background: "#FFFBE6",
          color: "#E56401",
        },
        {
          id: 4,
          name: "Riesgo Sustancial",
          icon: require("@/assets/images/icons/icon-matriz-iper/risk-sustancial.png"),
          score: [70, 200],
          text: "Requiere corrección",
          background: "#FEFFC8",
          color: "#425777",
        },
        {
          id: 5,
          name: "Riesgo posible",
          icon: require("@/assets/images/icons/icon-matriz-iper/risk-posible.png"),
          score: [20, 70],
          text: "Requiere supervisión - atención",
          background: "#E6F7FF",
          color: "#263238",
        },
        {
          id: 6,
          name: "Riesgo leve",
          icon: require("@/assets/images/icons/icon-matriz-iper/risk-leve.png"),
          score: [19],
          text: "Riesgo aceptable",
          background: "#F6FFED",
          color: "#00761A",
        },
      ],
      params: {},
    };
  },
  methods: {
    async loadAreas() {
      const me = this;
      me.areas = [];
      me.loadingArea = true;
      try {
        const { data } = await getAreas();
        me.areas = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingArea = false;
      }
    },
    async loadPositions() {
      const me = this;
      me.positions = [];
      me.loadingPosition = true;
      if (me.abortController) {
        me.abortController.abort(); // Cancela la petición anterior
      }

      me.abortController = new AbortController();
      const signal = me.abortController.signal;
      try {
        const { data } = await getPositionByArea(
          me.formData.area.id,
          {
            q: me.search,
          },
          signal
        );
        me.positions = data?.data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingPosition = false;
      }
    },
    async loadDetailArea() {
      const me = this;
      me.loadingDetailArea = true;
      if (me.abortControllerDetail) {
        me.abortControllerDetail.abort(); // Cancela la petición anterior
      }

      me.abortControllerDetail = new AbortController();
      const signal = me.abortController.signal;
      try {
        const { data } = await getAreaDetail(
          me.formData.area.id,
          {
            page: me.page,
          },
          signal
        );
        me.dataDetailArea = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingDetailArea = false;
      }
    },
    async loadAreaActivities() {
      const me = this;
      me.isLoadingActivitiesArea = true;
      try {
        const { data } = await getAreaActivities(me.formData.area?.id, {
          page: me.pageAllActivitiesArea,
          ...me.params,
        });
        me.dataTable = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoadingActivitiesArea = false;
      }
    },
    selectedArea(value) {
      const me = this;
      me.idPosition = null;
      me.dataDetailArea = null;
      me.formData.position = null;
      me.positions = [];
      me.formData.area = value;
      me.loadPositions();
      me.loadAreaActivities();
    },
    searchPosition(value) {
      const me = this;
      me.search = value;
      me.loadPositions();
    },
    selectedPosition(value) {
      const me = this;
      me.formData.position = value;
      me.title = `${me.formData.area.name} - ${me.formData.position.name}`;
      me.idPosition = value.id;
      me.loadDetailArea();
    },
    loadRowsPag(page) {
      const me = this;
      me.page = page;
      me.loadDetailArea();
    },
    loadRowsPagActivitiesArea(page) {
      const me = this;
      me.pageAllActivitiesArea = page;
      me.getAreaActivities();
    },
    submitFilter(values) {
      const me = this;
      me.params = { ...values };
      me.loadAreaActivities();
    },
  },
  mounted() {
    const me = this;
    me.loadAreas();
  },
};
</script>

<style lang="css">
.button-filter-matriz {
  border: 1px solid #5d5fef;
  border-radius: 20px;
  color: #5d5fef;
  font-size: 18px;
  background-color: white;
  padding: 4px 16px 4px 16px;
}
.risk-activity {
  background-color: #fffbe6;
  width: 70%;
  padding: 5px;
  border-radius: 8px;
}
.risk-activity span {
  font-weight: 500 !important;
  /* color: #E56401 !important; */
}
</style>
